module.exports = __webpack_public_path__ + "static/media/cloud-snow.fca02190.png";